// @flow
import React, { useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Dropdown, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Restricted from "../helpers/permission/Restricted";
import { useSelector } from "react-redux";
// Components
import ProfileImageContext from "../helpers/ProfileImageProvider";
// import Spinner from "./Spinner";

const ProfileDropdown = (props, state) => {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const { user } = useSelector((state) => ({
    user: state.Auth.user,
  }));
  const profileImageContext = useContext(ProfileImageContext);
  /*
   * toggle profile-dropdown
   */
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
      <Dropdown.Toggle
        variant="link"
        id="dropdown-profile"
        as={Link}
        to={location.search ? location.search : location.pathname}
        onClick={toggleDropdown}
        className="nav-link dropdown-toggle nav-user arrow-none me-0"
      >
        {!profileImageContext.loading && (
          <React.Fragment>
            {profileImageContext.image && (
              <span className="account-user-avatar">
                <img
                  src={profileImageContext.image}
                  className="rounded-circle"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </span>
            )}
            {!profileImageContext.image && (
              <div className="account-user-avatar">
                <div className="avatar-user-initials">
                  <span
                    className="avatar-title bg-primary-lighten font-15 rounded-circle"
                    style={{ color: "#DC222F" }}
                  >
                    {props.firstName ? props.firstName.charAt(0) : ""}
                    {props.lastName ? props.lastName.charAt(0) : ""}
                  </span>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
        {/* {loading && <Spinner className="account-user-avatar" />} */}

        <span>
          <span className="account-user-name">{props.username}</span>
          <span className="account-position">{props.userTitle}</span>
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown">
        <div onClick={toggleDropdown}>
          <div>
            {user.type !== "administration" && user.contactPerson && (
              <Container>
                <h4>{t("Your Contact Person")}</h4>
                <p>
                  <b>
                    {user.contactPerson.firstName +
                      " " +
                      user.contactPerson.lastName}
                  </b>
                  <br />
                  {user.contactPerson.position}
                  <br />
                  <a href={"mailto:" + user.contactPerson.email}>
                    {user.contactPerson.email}
                  </a>
                  <br />
                  <a href={"tel:" + user.contactPerson.phone}>
                    {user.contactPerson.phone}
                  </a>
                  <br />
                </p>
              </Container>
            )}
          </div>
          {/* <div className="dropdown-header noti-title">
            <h6 className="text-overflow m-0">Welcome !</h6>
          </div> */}
          {props.menuItems.map((item, i) => {
            /*             if(item.restrictedTo.length>0){
              return(<Restricted to={item.restrictedTo}>
              <Link
                to={item.redirectTo}
                className="dropdown-item notify-item"
                key={i + "-profile-menu"}
              >
                <i className={`${item.icon} me-1`}></i>
                <span>{item.label}</span>
              </Link>
              </Restricted>)
            } */

            return (
              <React.Fragment key={i + "-profile-menu"}>
                {item.restrictedTo !== "" && (
                  <Restricted to={item.restrictedTo}>
                    <Link
                      to={item.redirectTo}
                      className="dropdown-item notify-item"
                    >
                      <i className={`${item.icon} me-1`}></i>
                      <span>{t(item.label)}</span>
                    </Link>
                  </Restricted>
                )}
                {item.restrictedTo === "" && (
                  <Link
                    to={item.redirectTo}
                    className="dropdown-item notify-item"
                  >
                    <i className={`${item.icon} me-1`}></i>
                    <span>{t(item.label)}</span>
                  </Link>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
